var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 15 15",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("path", {
        attrs: {
          d:
            "M7.5 1.25C5.8625 1.25 4.53125 2.58125 4.53125 4.21875C4.53125 5.825 5.7875 7.125 7.425 7.18125C7.475 7.175 7.525 7.175 7.5625 7.18125C7.575 7.18125 7.58125 7.18125 7.59375 7.18125C7.6 7.18125 7.6 7.18125 7.60625 7.18125C9.20625 7.125 10.4625 5.825 10.4688 4.21875C10.4688 2.58125 9.1375 1.25 7.5 1.25Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          d:
            "M10.6746 8.8438C8.93086 7.6813 6.08711 7.6813 4.33086 8.8438C3.53711 9.37505 3.09961 10.0938 3.09961 10.8625C3.09961 11.6313 3.53711 12.3438 4.32461 12.8688C5.19961 13.4563 6.34961 13.75 7.49961 13.75C8.64961 13.75 9.79961 13.4563 10.6746 12.8688C11.4621 12.3375 11.8996 11.625 11.8996 10.85C11.8934 10.0813 11.4621 9.3688 10.6746 8.8438Z",
          fill: _vm.color
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }